import axiosPost from "./axiosPost";

export const RNESRubroIns = async (credentials, data) => {
    const body = {
        service: "RNESRubroIns",
        params: {
            rnesRubroNombre: data?.name || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
